import { render, staticRenderFns } from "./CreateLink.vue?vue&type=template&id=16c30ccb"
import script from "./CreateLink.vue?vue&type=script&lang=js"
export * from "./CreateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports